export default "22b28191ac0aff40.svg"